:host {
  --aha-ez-tabs--gap: 0;

  display: block;
  width: 100%;
  max-width: 100%;
}

#layout {
  display: flex;
  flex-direction: column;
  gap: var(--aha-ez-tabs--gap);
  width: 100%;
  height: 100%;
}
